import { s as makeRestApiRequest } from "./utils2.mjs";

//#region src/api/instance-registry.ts
const getClusterInfo = async (context) => {
	return await makeRestApiRequest(context, "GET", "/instance-registry");
};

//#endregion
export { getClusterInfo as t };
//# sourceMappingURL=instance-registry.mjs.map